import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Validator from 'validatorjs';

import {
  Form,
  Button,
  Modal,
  Message,
  Icon,
  Input,
  TextArea,
  Select,
} from 'semantic-ui-react';

import { MARKET_FACTOR_COLORS, MARKET_FACTOR_STATUS } from '../../constants';

class MarketFactorForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      title: '',
      description: '',
      color: '',
      status: '',
      errors: {},
    };
  }

  componentDidMount() {
    const { marketFactor } = this.props;
    if (!isEmpty(marketFactor)) {
      const {
        id, title, description, color, status,
      } = marketFactor;

      this.setState({
        id: parseInt(id, 10),
        title,
        description,
        color,
        status,
      });
    }
  }

  render() {
    const {
      isModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
    } = this.props;

    const {
      id, title, description, color, status, errors,
    } = this.state;

    const onChangeHandler = field => event => {
      this.setState({ [field]: event.target.value });
    };

    const onSelectHandler = field => (event, data) => {
      this.setState({ [field]: data.value });
    };

    const validationRules = {
      title: 'required',
      description: 'required',
      color: 'required',
      status: 'required',
    };

    const submitForm = () => {
      const validation = new Validator(this.state, validationRules);
      if (validation.fails()) {
        this.setState({ errors: validation.errors.all() });
        return false;
      }
      onSubmitHandler({
        title,
        description,
        color,
        status,
      });
      this.setState({ errors: {} });
      return true;
    };

    return (
      <Modal
        open={isModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        {id && <Modal.Header>Edit Market Factor</Modal.Header>}
        {!id && <Modal.Header>New Market Factor</Modal.Header>}
        <Modal.Content image scrolling>
          <Modal.Description>
            {error && (
              <Message negative>
                <p>{error}</p>
              </Message>
            )}
            <Form>
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.title)}>
                  <label htmlFor='title'>Title</label>
                  <Input
                    id='title'
                    name='title'
                    value={title}
                    onChange={onChangeHandler('title')}
                  />
                  {errors.title && <span>{errors.title}</span>}
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.title)}>
                  <label htmlFor='description'>Description</label>
                  <TextArea
                    id='description'
                    name='description'
                    value={description}
                    onChange={onChangeHandler('description')}
                  />
                  {errors.description && <span>{errors.description}</span>}
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.color)}>
                  <label htmlFor='color'>Color</label>
                  <Select
                    id='color'
                    placeholder='Select color'
                    options={MARKET_FACTOR_COLORS}
                    onChange={onSelectHandler('color')}
                    value={color}
                  />
                  {errors.color && <span>{errors.color}</span>}
                </Form.Field>
                <Form.Field required error={!isEmpty(errors.status)}>
                  <label htmlFor='status'>Status</label>
                  <Select
                    id='status'
                    placeholder='Select status'
                    options={MARKET_FACTOR_STATUS}
                    onChange={onSelectHandler('status')}
                    value={status}
                  />
                  {errors.status && <span>{errors.status}</span>}
                </Form.Field>
              </Form.Group>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {submitting && (
            <Button loading positive>
              Submitting...
            </Button>
          )}

          {!submitting && (
            <Button color='green' onClick={submitForm} inverted>
              <Icon name='checkmark' /> {id ? 'Update' : 'Create'}
            </Button>
          )}
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

MarketFactorForm.propTypes = {
  marketFactor: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    description: PropTypes.string,
    color: PropTypes.string,
    status: PropTypes.string,
  }),
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  onSubmitHandler: PropTypes.func,
  error: PropTypes.string,
  submitting: PropTypes.bool,
};

MarketFactorForm.defaultProps = {
  marketFactor: {},
  isModalOpen: false,
  onCloseHandler: () => {},
  onSubmitHandler: () => {},
  error: '',
  submitting: false,
};

export default MarketFactorForm;
